// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__OWljs","imgContainer":"card_imgContainer__GnXuw","icons":"card_icons__P3er2"};